export const ACCOUNT_MENU = 'ACCOUNT_MENU';
export const FAVOURITES = 'FAVOURITES';
export const FILTERS_MENU = 'FILTERS_MENU';
export const MOBILE_MENU = 'MOBILE_MENU';
